import { Stack } from 'expo-router';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { ChatListSidebar } from '~/chat/components/chat-list-sidebar/ChatListSidebar';
import { ChatHeader } from '~/chat/components/chat-header/ChatHeader';
import { ChatMobileHeader } from '~/chat/components/chat-mobile-header/ChatMobileHeader';

/**
 * Persistent chrome for the chat screen — header, mobile header and the
 * right-sidebar conversation list — wrapping the nested `index` / `[niceId]`
 * Stack that renders the conversation window. Keeping the rail here (rather than
 * inside each route) means it survives navigating between conversations: the
 * `RightSidebar` registration stays focused across the `index ↔ [niceId]`
 * transition instead of unregistering and re-registering. Mirrors the
 * workouts `(detail)/_layout`.
 *
 * Chat is available to every authenticated user — Free users run it against
 * their monthly FYT credit allotment — so there is no entitlement gate here; an
 * empty wallet is handled at send time (see `Chat.onSubmit`).
 */
export default function ChatLayout() {
  return (
    <FullHeightWrapper>
      <ChatHeader />
      <ChatMobileHeader />
      <ChatListSidebar />
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="index" />
        <Stack.Screen name="[niceId]/index" />
      </Stack>
    </FullHeightWrapper>
  );
}
